import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUser } from 'contexts';
import { getLastSaleDaybook } from '../redux/actions/salesInvoice';
import { getLastSaleChallanDaybook } from '../redux/actions/salesChallan';
import moment from 'moment';

const useSalesChallanLastDaybook = () => {
   const [selectedDaybookId, setSelectedDaybookId] = useState(null);
   const { user } = useUser();
   const dispatch = useDispatch();
   const lastSaleDaybook = useSelector((state) => state.salesChallan.lastSaleDaybook);

   const getLastSalesDaybook = useCallback(async () => {
      if (user && user?.loginhistory?.companyId) {
         const fromDate = localStorage.getItem('selectedFy_start_date');
         const toDate = localStorage.getItem('selectedFy_end_date');
         const params = {
            companyId: user.loginhistory.companyId,
            fromDate: moment(fromDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            toDate: moment(toDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            ...(selectedDaybookId && { daybookId: selectedDaybookId }),
         };
         await dispatch(getLastSaleChallanDaybook(params));
      }
   }, [dispatch, selectedDaybookId, user]);

   useEffect(() => {
      getLastSalesDaybook();
   }, [getLastSalesDaybook]);

   return {
      lastSaleDaybook,
      setSelectedDaybookId,
   };
};

export default useSalesChallanLastDaybook;
